module.exports = __webpack_public_path__ + "img/solution-software-system-pic-3.01315ddd.png";